/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";

class GuideMember extends Component {
    rowClassName = "";

    state = {
        showingTabletDetail: false,
    };

    toggleTabletDetail = () => {
        let showing = this.state.showingTabletDetail;
        this.setState({ showingTabletDetail: !showing });
    };

    renderDate = (dateString) => {
        let d = new Date(dateString);
        return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
    };
    renderTabletModeDetail = (t) => {
        if (!this.state.showingTabletDetail) return null;

        return (
            <tr className="child">
                <td className="child" colspan="2">
                    <table>
                        <tr data-dt-row="0" data-dt-column="2">
                            <td>
                                <div className="tableTitle"><Trans desc="guidemainStep">guidemainStep</Trans></div>
                            </td>
                            <td>{t.mainStep}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="5">
                            <td>
                                <div className="tableTitle"><Trans desc="guidesubStep">guidesubStep</Trans></div>
                            </td>
                            <td>{t.subStep}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="3">
                            <td>
                                <div className="tableTitle"><Trans desc="guidedescription">guidedescription</Trans></div>
                            </td>
                            <td>{t.description}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="3">
                            <td>
                                <div className="tableTitle"><Trans desc="guideaffectedDepartment">guideaffectedDepartment</Trans></div>
                            </td>
                            <td>{t.affectedDepartment}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="6">
                            <td>
                                <div className="tableTitle"><Trans desc="guideresponsibleParty">guideresponsibleParty</Trans></div>
                            </td>
                            <td>{t.responsibleParty}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="7">
                            <td>
                                <div className="tableTitle"><Trans desc="guideresponsiblepartytwo">guideresponsiblepartytwo</Trans></div>
                            </td>
                            <td>{t.gsc_responsiblepartytwo}</td>
                        </tr>
                        <tr data-dt-row="0" data-dt-column="8">
                            <td>
                                <div className="tableTitle"><Trans desc="guideresponsiblepartythree">guideresponsiblepartythree</Trans></div>
                            </td>
                            <td>{t.gsc_responsiblepartythree}</td>
                        </tr>
                    </table>
                </td>
            </tr>
        );
    };

    render() {
        const { mem } = this.props;
        return (
            <>
                <DesktopBreakpoint>
                    <tr className={this.rowClassName}>
                        <td className="showGrup">{mem.mainStep}</td>
                        <td className="showGrup">
                            {mem.subStep}
                        </td>
                        <td className="showGrup">{mem.affectedDepartment}</td>
                        <td className="showGrup">{mem.description}</td>
                        <td className="showGrup">{mem.responsibleParty}</td>
                        <td className="showGrup">{mem.gsc_responsiblepartytwo}</td>
                        <td className="showGrup">{mem.gsc_responsiblepartythree}</td>
                    </tr>
                </DesktopBreakpoint>
                <TabletBreakpoint>
                    <tr className={this.rowClassName} onClick={this.toggleTabletDetail}>
                        <td className="showGrup">{mem.mainStep}</td>
                    </tr>
                    {this.renderTabletModeDetail(mem)}
                </TabletBreakpoint>
            </>
        );
    }
}

export default GuideMember;
